import request from "./request";
import { CHANNEL_SERVER, FILE_SERVER, USER_SERVER } from "./constants";
export interface UpdateUserInfoData {
    nickname?: string;
    role?: number;
    gender?: string;
    country?: string;
    birthday?: number;
    logo?: string;
    password?: string; // 后端说使用updateUserInfo接口来更新密码
}

export const updateUserInfo = async (
    data: UpdateUserInfoData,
): Promise<{
    user_id: string;
}> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/info",
        method: "put",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface ChangePasswordData {
    account: string;
    verification_code: string;
    password: string;
    mobile_id: string;
    client_type: string;
}

export const changePassword = async (data: ChangePasswordData): Promise<{ user_id: string }> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/forget-pwd",
        method: "put",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface BindNewAccountData {
    new_account: string;
    verification_code: string;
    mobile_id: string;
}

export const bindNewAccount = async (data: BindNewAccountData): Promise<{ user_id: string }> => {
    return request({
        url: USER_SERVER + "/ums/v1/game/account-change",
        method: "post",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface RefreshTokenData {
    refresh_token: string;
    client_type: string;
}

export const refreshToken = async (data: RefreshTokenData): Promise<{ token: string }> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/refresh-token",
        method: "put",
        data,
    });
};

export const validToken = async (token: string): Promise<{ valid: boolean }> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/auth/validation",
        method: "post",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export interface DeregisterAccountData {
    verification_code: string;
    soft_delete_flag: boolean;
    mobile_id: string;
}
export interface UploadProps {
    // cspell:disable-next-line
    type: string; // normal/dingding/firmware/software/article/comment/device_log（设备日志）
    md5_flag: boolean; // 布尔值，true标识需要MD5
    files: FormData;
}

export interface FileResult {
    files: Array<{
        file_name: string;
        url: string;
        size: number;
        md5: string;
    }>;
}
export const deregisterAccount = async (
    data: DeregisterAccountData,
): Promise<{ token: string }> => {
    return request({
        url: USER_SERVER + "/ums/v1/game/cancel",
        method: "post",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};
// 批量上传文件 - 用于上传头像\举报证据
export const uploadFile = async (data: UploadProps): Promise<FileResult> => {
    return request({
        url: FILE_SERVER + `/fms/v1/files/batch-upload?type=${data.type}&md5_flag=${data.md5_flag}`,
        method: "post",
        data: data.files,
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface UserInfoResult {
    nickname: string;
    email?: string;
    phone?: string;
    account: string;
    user_id: string;
    role: number;
    gender: string;
    birthday: number;
    logo: string;
    subscriber_state: string;
    member_details_in_use: MemberDetailsInUse;
    platform_relations: PlatformRelation[];
    has_pwd_flag: boolean;
}

export interface MemberDetailsInUse {
    membership_level: string;
    is_product_recurring: boolean;
    is_recurring: boolean;
    member_expiration_timestamp: number;
    member_next_renewal_timestamp: number;
    payment_type: string;
    order_id: OrderId;
    is_upgrading_allowed: boolean;
}

export interface OrderId {}

export interface PlatformRelation {
    platform_user_name?: string;
    platform?: string;
    union_id?: string;
    head_img?: string;
}

// 获取用户信息
export const getUserInfo = async (): Promise<UserInfoResult> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/infos",
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface GetSDKIDResult {
    data: { sdkAppId: number; userSig: string };
    code: string;
    msg: string;
}

// 获取SDKID
export const getSDKID = async (userId: string): Promise<GetSDKIDResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/appid?id=" + userId,
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 修改用户在线状态
export const changeUserStatus = async (status: string): Promise<any> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/tencent/set",
        method: "post",
        data: {
            status,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

// 根据关键字查询用户列表
export const queryUserList = async (params: string): Promise<any> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/friendinfo",
        method: "post",
        data: {
            account: params,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface CheckPassSameResult {
    code: string;
    data: "true" | "false";
    msg: string;
}

// 修改密码判断旧密码和新密码是否相同
export const checkPassSame = async (password: string): Promise<CheckPassSameResult> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/compare",
        method: "post",
        data: {
            password,
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};
